/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { CalloutContext, useOkapiKy } from '@folio/stripes/core';
import { FormattedMessage, useIntl } from 'react-intl';
import TemplateBuilder from '../TemplateBuilder';
import useTemplate from '../../../../hooks/useTemplate';

function DuplicateTemplate(props) {
  const history = useHistory();
  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  const { templateId } = useParams();
  const { templates, isLoading } = useTemplate(templateId);
  const intl = useIntl();

  const localizedName = templates?.name?.find(
    (field) => field?.locale === intl.locale,
  )?.value;

  const duplicatedName = templates?.name.map(({ locale, value }) => ({
    locale,
    value: `Copy of ${value}`,
  }));

  const initialValues = useMemo(
    () => ({
      templateInfo: {
        name: duplicatedName,
        description: templates?.description,
        code: `copy${templates?.code}`,
        isDefault: templates?.isDefault,
        isLocked: templates?.isLocked,
        active: templates?.active,
      },
      templateFields: templates?.templateFields,
    }),
    [templateId, isLoading],
  );

  const onSubmit = (values) => {
    okapiKy
      .post('inventory-templates', {
        timeout: 30000,
        method: 'POST',
        json: {
          ...values.templateInfo,
          templateFields: values.templateFields,
        },
      })
      .json()
      .then((res) => {
        if (res.id) {
          const message = (
            <FormattedMessage
              id="ui-plugin-inventory-templates.createTemplate.callout.created"
              defaultMessage="Template created successfully"
            />
          );
          history.push(`${props.basePath}/${res.id}/view`);
          context.sendCallout({ message });
        }
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  return (
    <TemplateBuilder
      initialValues={initialValues}
      onSubmit={onSubmit}
      paneTitle={
        <FormattedMessage
          id="ui-plugin-inventory-templates.duplicateTemplate.pane.paneTitle"
          values={{ template: localizedName }}
          defaultMessage="Duplicate {template} template"
        />
      }
      isLoading={isLoading}
    />
  );
}

DuplicateTemplate.propTypes = {
  basePath: PropTypes.string,
};

export default DuplicateTemplate;
